let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("6J8zs")).then(() => parcelRequire('9ARY2'));